


// import React, { useContext } from "react";
// import {
//   Headphones,
//   Send,
//   MessageCircle,
//   ShieldCheck,
//   Clock,
//   ChevronRight,
//   Sparkles,
//   Zap,
//   Radio
// } from "lucide-react";
// import Rightcontainer from "../Components/Rightcontainer";
// import { LanguageContext } from "../Components/LanguageContext";
// // import "./Support.css";

// const Support = () => {
//   const { language } = useContext(LanguageContext);

//   // Get settings from localStorage safely
//   const siteSetting = JSON.parse(localStorage.getItem("sitSetting")) || {};

//   const translations = {
//     hi: {
//       help: "24/7 सहायता केंद्र",
//       sub: "क्या आपको कोई समस्या है? हम सहायता के लिए यहाँ हैं",
//       contact: "संपर्क माध्यम चुनें",
//       telegram: "टेलीग्राम सपोर्ट",
//       whatsapp: "व्हाट्सएप चैट",
//       quick: "त्वरित प्रतिक्रिया (2-5 मिनट)",
//       instant: "इंस्टेंट चैट सहायता",
//       secure: "100% सुरक्षित और गोपनीय सहायता",
//       online: "ऑनलाइन एजेंट उपलब्ध हैं",
//     },
//     en: {
//       help: "24/7 Support Center",
//       sub: "Having an issue? Our team is active & ready to assist",
//       contact: "Choose a contact channel",
//       telegram: "Telegram Support",
//       whatsapp: "WhatsApp Chat",
//       quick: "Quick Response (2-5 mins)",
//       instant: "Instant live chat support",
//       secure: "100% Secure & Confidential Support",
//       online: "Live Agents Online",
//     },
//   };

//   const t = translations[language] || translations.en;

//   const telegramLink = siteSetting.supportTelegram || "https://t.me/";
//   const whatsappLink = siteSetting.whatsappSupport || "https://wa.me/";

//   return (
//     <div className="sa-support-wrapper leftContainer mt-5 pt-5">
//       {/* Background Ambient Mesh Lights */}
//       <div className="support-ambient glow-1"></div>
//       <div className="support-ambient glow-2"></div>
//       <div className="support-ambient glow-3"></div>

//       <div className="sa-support-container mb-5">
        
//         {/* Header Hero Card */}
//         <div className="sa-support-hero">
//           <div className="sa-hero-bg-glow"></div>
          
//           <div className="sa-hero-top">
//             <div className="sa-online-status">
//               <span className="sa-pulse-dot"></span>
//               <Radio size={14} className="sa-radio-icon" />
//               <span>{t.online}</span>
//             </div>
//             <div className="sa-badge-pill">
//               <Sparkles size={14} className="sparkle-icon" />
//               <span>24/7 VIP Help</span>
//             </div>
//           </div>

//           <div className="sa-support-header">
//             <div className="sa-help-icon-wrap">
//               <Headphones size={32} className="sa-main-icon" />
//             </div>
//             <div className="sa-header-text">
//               <h1 className="sa-support-title">{t.help}</h1>
//               <p className="sa-support-sub">{t.sub}</p>
//             </div>
//           </div>
//         </div>

//         {/* Channels Section */}
//         <div className="sa-support-body">
//           <div className="sa-section-header">
//             <h3 className="sa-section-title">{t.contact}</h3>
//             <span className="sa-time-badge">
//               <Clock size={14} /> 24/7 Active
//             </span>
//           </div>

//           <div className="sa-grid-options">
            
//             {/* Telegram Card */}
//             <a
//               href={telegramLink}
//               className="sa-contact-card telegram-theme"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <div className="sa-card-glow"></div>
//               <div className="sa-card-left">
//                 <div className="sa-card-icon telegram">
//                   <Send size={22} className="card-icon-anim" />
//                 </div>
//                 <div className="sa-card-info">
//                   <div className="sa-card-title-row">
//                     <h4>{t.telegram}</h4>
//                     <span className="sa-speed-pill cyan">
//                       <Zap size={12} /> Fast
//                     </span>
//                   </div>
//                   <span className="sa-card-sub">{t.quick}</span>
//                 </div>
//               </div>
//               <div className="sa-arrow-circle">
//                 <ChevronRight size={18} className="sa-card-arrow" />
//               </div>
//             </a>

//             {/* WhatsApp Card */}
//             <a
//               href={whatsappLink}
//               className="sa-contact-card whatsapp-theme"
//               target="_blank"
//               rel="noreferrer"
//             >
//               <div className="sa-card-glow"></div>
//               <div className="sa-card-left">
//                 <div className="sa-card-icon whatsapp">
//                   <MessageCircle size={22} className="card-icon-anim" />
//                 </div>
//                 <div className="sa-card-info">
//                   <div className="sa-card-title-row">
//                     <h4>{t.whatsapp}</h4>
//                     <span className="sa-speed-pill green">
//                       <Zap size={12} /> Instant
//                     </span>
//                   </div>
//                   <span className="sa-card-sub">{t.instant}</span>
//                 </div>
//               </div>
//               <div className="sa-arrow-circle">
//                 <ChevronRight size={18} className="sa-card-arrow" />
//               </div>
//             </a>

//           </div>

//           {/* Secure Trust Box */}
//           <div className="sa-secure-box">
//             <ShieldCheck size={20} className="sa-shield" />
//             <span>{t.secure}</span>
//           </div>
//         </div>

//       </div>

//       <div className="rightContainer hidden-mobile">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Support;



import React, { useContext } from "react";
import {
  Headphones,
  Send,
  MessageCircle,
  ShieldCheck,
  Zap,
  ChevronRight
} from "lucide-react";
import Rightcontainer from "../Components/Rightcontainer";
import { LanguageContext } from "../Components/LanguageContext";
// import "../css/Support.css";

const Support = () => {
  const { language } = useContext(LanguageContext);

  // Get settings from localStorage safely
  const siteSetting = JSON.parse(localStorage.getItem("sitSetting")) || {};

  const translations = {
    hi: {
      helpCenter: "सहायता केंद्र",
      supportTitle: "सपोर्ट",
      supportSub: "अपने KRLUDO अकाउंट के लिए त्वरित सहायता — नीचे एक माध्यम चुनें।",
      quickReply: "1-2 मिनट उत्तर",
      secure: "सुरक्षित",
      twentyFourSeven: "24x7",
      channels: "संपर्क माध्यम",
      telegram: "टेलीग्राम",
      telegramSub: "ऑफिशियल चैनल",
      whatsapp: "व्हाट्सएप",
      whatsappSub: "व्हाट्सएप पर चैट करें",
      contactBtn: "संपर्क करें",
      openChatBtn: "चैट खोलें"
    },
    en: {
      helpCenter: "HELP CENTER",
      supportTitle: "SUPPORT",
      supportSub: "Fast help for your KRLUDO account — pick a channel below.",
      quickReply: "1–2 min reply",
      secure: "Secure",
      twentyFourSeven: "24x7",
      channels: "CHANNELS",
      telegram: "Telegram",
      telegramSub: "Official channel",
      whatsapp: "WhatsApp",
      whatsappSub: "Chat on WhatsApp",
      contactBtn: "Contact",
      openChatBtn: "Open Chat"
    },
  };

  const t = translations[language] || translations.en;

  const telegramLink = siteSetting.supportTelegram || "https://t.me/";
  const whatsappLink = siteSetting.whatsappSupport || "https://wa.me/";

  return (
    <div className="ce-support-wrapper leftContainer mt-5 pt-5">
      <div className="ce-support-container mb-5">
        
        {/* Header Hero Card */}
        <div className="ce-support-hero-card">
          <div className="ce-badge-pill">
            <Headphones size={13} className="ce-emerald-icon" />
            <span>{t.helpCenter}</span>
          </div>

          <h1 className="ce-support-title">{t.supportTitle}</h1>
          <p className="ce-support-sub">{t.supportSub}</p>

          <div className="ce-feature-pills-row">
            <div className="ce-mini-pill">
              <Zap size={13} />
              <span>{t.quickReply}</span>
            </div>
            <div className="ce-mini-pill">
              <ShieldCheck size={13} />
              <span>{t.secure}</span>
            </div>
            <div className="ce-mini-pill">
              <Headphones size={13} />
              <span>{t.twentyFourSeven}</span>
            </div>
          </div>
        </div>

        {/* Channels Section */}
        <div className="ce-channels-section">
          <span className="ce-channels-label">{t.channels}</span>

          <div className="ce-channels-list">
            
            {/* WhatsApp Card */}
            <div className="ce-channel-card">
              <div className="ce-channel-left">
                <div className="ce-channel-icon-box">
                  <MessageCircle size={20} className="ce-emerald-icon" />
                </div>
                <div className="ce-channel-info">
                  <h3 className="ce-channel-title">{t.whatsapp}</h3>
                  <p className="ce-channel-sub">{t.whatsappSub}</p>
                </div>
              </div>

              <a
                href={whatsappLink}
                target="_blank"
                rel="noreferrer"
                className="ce-channel-btn primary"
              >
                <span>{t.contactBtn}</span>
                <ChevronRight size={16} />
              </a>
            </div>

            {/* Telegram Card */}
            <div className="ce-channel-card">
              <div className="ce-channel-left">
                <div className="ce-channel-icon-box">
                  <Send size={20} className="ce-emerald-icon" />
                </div>
                <div className="ce-channel-info">
                  <h3 className="ce-channel-title">{t.telegram}</h3>
                  <p className="ce-channel-sub">{t.telegramSub}</p>
                </div>
              </div>

              <a
                href={telegramLink}
                target="_blank"
                rel="noreferrer"
                className="ce-channel-btn primary"
              >
                <span>{t.openChatBtn}</span>
                <ChevronRight size={16} />
              </a>
            </div>

          </div>
        </div>

      </div>

      <div className="rightContainer hidden-mobile">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;